export const homeTitles = {
    default: 'Монетарные операции НБ РБ',
    Home: 'Монетарные операции НБ РБ',
    NewsList: 'Новости портала',
    NewsListPrint: 'Новости портала -- Версия для печати',
    MessagesList: 'Новости сайта НБ РБ',
    MessagesListPrint: 'Новости сайта НБ РБ - Версия для печати',
    ContactsHome: 'Предметные специалисты',
    ContactsTechnical: 'Технические специалисты',
    LinksList: 'Нормативные документы',
    GuestList: 'Гости',
    GuestEditor: 'Гости',
    GuestView: 'Гости',
    UserGuide: 'Руководства пользователя',
    AuctionResults: 'Итоги аукционов',
    Application: 'Программы',
    ArticlesList: 'Аппаратно - программные требования',
    ArticlesListPrint: 'Аппаратно - программные требования - Версия для печати',
    InterestRates: 'Ставки по операциям',
    LombList: 'Виды обеспечения',
    LoanList: 'Подробный перечень ценных бумаг, входящий в ломбардный список',
    LoanListPrint: 'Подробный перечень ценных бумаг, входящий в ломбардный список - Версия для печати',
    Charts: 'Графики, регламенты',
    ChartsPrint: 'Графики, регламенты -- Версия для печати',
    LiquidityPlan: 'Планируемые операции (бел. рубли)',
    LiquidityPlanPrint: 'Планируемые операции (бел. рубли) - Версия для печати',
    LiquidityPlanCur: 'Планируемые операции (ин. валюта)',
    LiquidityPlanCurPrint: 'Планируемые операции (ин. валюта) - Версия для печати',
    Registry: 'Реестр выпусков облигаций Национального Банка',
    DetailsRegistry: 'Реестр выпусков облигаций Национального Банка',
    DetailsRegistryPrint: 'Реестр выпусков облигаций Национального Банка - Версия для печати'
};
export const loginTitles = {
    default: 'Авторизация',
    Login: 'Авторизация',
};
export const applicationTitles = {
    default: 'Монетарные операции НБ РБ',
    electronic_auction: 'Электронный аукцион',
    deposit_auction: 'Депозиты банков. Подача завок',
    pledge: 'Управление залогом',
    deposit: 'Депозиты',
    electronic_auction_test: 'Тест - Электронный аукцион',
    pledge_test: 'Тест - Управление залогом',
    deposit_test: 'Тест - Депозиты'
};
export const adminTitles = {
    default: 'Монетарные операции НБ РБ',
    NewsHome: 'Новости',
    NewsEditor: 'Новости',
    NewsCopy: 'Новости',
    NewsView: 'Новости',
    ContactsHome: 'Контакты',
    ContactsEditor: 'Контакты',
    ContactsView: 'Контакты',
    LinksHome: 'Ссылки',
    LinksEditor: 'Ссылки',
    LinksView: 'Ссылки',
    ArticlesHome: 'Статьи',
    ArticlesEditor: 'Статьи',
    ArticlesView: 'Статьи',
    PermissionsHome: 'Управление правами',
    DirectoriesTable: 'Справочники',
    UsersHome: 'Регистрация',
    UserEditor: 'Регистрация',
    UserView: 'Регистрация'
};


// WEBPACK FOOTER //
// ./common/constants/title_pages.ts